import ContentLoader, { IContentLoaderProps } from "react-content-loader"

import { useColorScheme } from "../../../../hooks/useColorScheme"

export function LoadingSkeleton(props: IContentLoaderProps) {
  const colorScheme = useColorScheme()

  const backgroundColor = colorScheme === "dark" ? "#374151" : "#f3f4f6"
  const foregroundColor = colorScheme === "dark" ? "#3E495B" : "#eee"

  return (
    <ContentLoader
      data-testid="loading-skeleton"
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      {...props}
    />
  )
}
